import * as tslib_1 from "tslib";
import { RelevanceFormControl } from "../../../../../../form/src/common/controls/relevance-form-control";
import { deepCopy } from "../../../../../../form/utils";
import { Icon, Select, Spin, Tooltip } from "@h3/antd-vue";
import { Component } from "vue-property-decorator";
let RelevanceFormDropdown = class RelevanceFormDropdown extends RelevanceFormControl {
    constructor() {
        super(...arguments);
        this.list = [];
        this.fetching = false;
        this.listAll = [];
    }
    created() {
        this.onSearch("");
    }
    get selectedId() {
        if (Array.isArray(this.ctrl.value)) {
            return this.ctrl.value.map((i) => i.id);
        }
        else if (this.ctrl.value) {
            if (this.ctrl.value.id) {
                return this.ctrl.value.id.split(";");
            }
            else {
                return [];
            }
        }
        else {
            return [];
        }
    }
    get selectedItem() {
        if (this.selectedId.length > 0 && this.list.length === 0) {
            let strRes = "";
            if (Array.isArray(this.ctrl.value)) {
                this.selectedId.forEach((item) => {
                    let chosenOne = this.ctrl.value.find((x) => x.id === item);
                    if (chosenOne) {
                        strRes += chosenOne[this.getDisplayField] + ";";
                    }
                });
                if (!strRes) {
                    strRes = strRes.substring(0, strRes.length - 1);
                }
                return strRes;
            }
            else if (this.ctrl.value) {
                return this.ctrl.value[this.getDisplayField];
            }
            else {
                return "";
            }
        }
        return "";
    }
    get drowdownList() {
        if (this.list.length) {
            let arr = [];
            for (let val of this.list) {
                if (val[this.getDisplayField] !== null) {
                    let value = this.parseDisplayFieldValue(val[this.getDisplayField], this.getDisplayField);
                    arr.push({
                        id: val.id,
                        [this.getDisplayField]: value,
                    });
                }
            }
            return arr;
        }
        else {
            return [];
        }
    }
    setControl() {
        super.setControl();
        if (this.selectedId.length > 0) {
            this.onFocus();
        }
    }
    onFocus() {
        this.search("");
    }
    onSearch(value) {
        clearTimeout(this.searchTimeoutRef);
        this.searchTimeoutRef = setTimeout(() => {
            this.search(value);
        }, 300);
    }
    search(value) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!value) {
                this.fetch(0, 1000, value, []).then((seg) => {
                    this.listAll = seg.data;
                    this.list = seg.data;
                });
            }
            else {
                if (this.queryConditions.length === 0 && this.controlOpts.conditions) {
                    const res = yield this.getConfig();
                    if (res && res.conditions) {
                        this.queryConditions = res.conditions;
                    }
                }
                if (this.fetching) {
                    return;
                }
                this.fetching = true;
                this.list = [];
                this.fetch(0, 1000, value, []).then((seg) => {
                    this.fetching = false;
                    this.list = seg.data;
                }, () => (this.fetching = false));
            }
        });
    }
    onChange(selectedId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (selectedId.length) {
                let arr = [];
                selectedId.forEach((i) => {
                    let current = this.listAll.find((x) => x.id === i);
                    if (current) {
                        arr.push(current);
                    }
                });
                let newArr = yield this.convertForMappings(arr);
                this.interceptorValue(newArr);
                this.setValue(newArr);
                setTimeout(() => {
                    this.setValue(deepCopy(newArr));
                }, 500);
            }
            else {
                this.ctrl.value = null;
            }
        });
    }
};
RelevanceFormDropdown = tslib_1.__decorate([
    Component({
        name: "relevance-form-dropdown",
        components: {
            ATooltip: Tooltip,
            ASelect: Select,
            ASelectOption: Select.Option,
            // ATreeSelect: TreeSelect,
            // ATreeSelectNode: TreeSelect.TreeNode,
            AIcon: Icon,
            ASpin: Spin,
        },
    })
], RelevanceFormDropdown);
export default RelevanceFormDropdown;
